import EDTooltip from '../../../../../../../../../BaseComponents/Tooltip/EDTooltip';
import EDChip from '../../../../../../../../../BaseComponents/Chip/EDChip';
import EDIcon from '../../../../../../../../../BaseComponents/Icon/EDIcon';
import { IconType } from '../../../../../../../../../BaseComponents/Icon/Utils/IconDefinitions';

interface IProps {
  disabled?: boolean;
  disabledReason?: string;
  tooltip?: string;
  label: string;
  icon: IconType;
  onClick: (value: boolean) => void;
  value: boolean;
  overrideVariant?: boolean;
  noDisabledColor?: boolean;
}

/**
 * Knapp för inställningar i analysutdelning
 */
const AnalysUtdelningSettingButton: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const {
    disabled,
    disabledReason,
    tooltip = '',
    label,
    icon,
    onClick,
    value,
    overrideVariant = false,
  } = props;

  return (
    <span>
      <EDTooltip
        title={disabled ? disabledReason : tooltip}
        enableClickOnTouch={disabled}
      >
        <span>
          <EDChip
            analysUtdelningSettingButton
            disabled={disabled}
            variant={value || overrideVariant ? undefined : 'outlined'}
            color="primary"
            label={label}
            icon={<EDIcon size="small" iconType={icon} />}
            onClick={disabled ? undefined : () => onClick(!value)}
          />
        </span>
      </EDTooltip>
    </span>
  );
};

export default AnalysUtdelningSettingButton;
